import { useDispatch, useSelector, useStore } from "react-redux";

import { rootReducer } from "../rootReducer";
import { store } from "../store";

type RootState = ReturnType<typeof rootReducer>;
type AppDispatch = typeof store.dispatch;
type AppStore = typeof store;

const useAppStore = useStore.withTypes<AppStore>();
const useAppSelector = useSelector.withTypes<RootState>();
const useAppDispatch = useDispatch.withTypes<AppDispatch>();

export { useAppDispatch, useAppSelector, useAppStore };
export type { AppDispatch, AppStore, RootState };
